/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { GrantCreateGranteeLevel } from './grantCreateGranteeLevel';
import type { GrantCreateKind } from './grantCreateKind';
import type { GrantCreateScope } from './grantCreateScope';

export interface GrantCreate {
  kind: GrantCreateKind;
  grantee_user_id?: string | null;
  grantee_level?: GrantCreateGranteeLevel;
  grantee_entity_id?: string | null;
  scope: GrantCreateScope;
  expires_at?: string | null;
}
